var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'horizontal')?_c('HorizontalDivider'):_c('VerticalDivider')}
var staticRenderFns = []

export { render, staticRenderFns }